import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  readonly toastState = signal<any>(null);
  readonly toastDetails$ = toObservable(this.toastState);
  readonly toastDetails = this.toastDetails$;

  show(toastType: any, message: any, position: any, leftPosition: any) {
    this.toastState.set({
      isShown: true,
      message: message,
      toastType: toastType,
      position: position,
      leftPosition: leftPosition
    });
  }

  hide() {
    this.toastState.set({
      isShown: false,
      message: '',
      toastType: null
    });
  }
}

export enum ToastType {
  Success,
  Error,
  Notification
}
